import { ICustomerDataFields } from '@/core/data_handlers/customer_data_new/types';
import { TsUtilityFunctions } from '@/core/event_logic/utils/ts_utils';
import { ShpyCpxHandlerInput } from '@/sources/bundles/wtag-shpfy-cpx/shopify_custom_pixel_types/cpx_payload_types';

const getNonNullValue = (values: (string | null | undefined)[]): string =>
  TsUtilityFunctions.returnArrayWithNonNullValues(values)[0] || '';

export const CpxCustomerDataHandler = {
  getCombinedCustomerData(
    cpx_input: ShpyCpxHandlerInput,
  ): ICustomerDataFields[] {
    const customer_info = cpx_input.init?.data?.customer;
    const checkout_info = cpx_input.event?.data?.checkout;
    const shipping_address = checkout_info?.shippingAddress;
    const billing_address = checkout_info?.billingAddress;

    const customerDataFields: ICustomerDataFields[] = [];

    // Create and add customer_info fields if available
    if (
      customer_info?.email ||
      customer_info?.phone ||
      customer_info?.firstName ||
      customer_info?.lastName
    ) {
      customerDataFields.push({
        cc: getNonNullValue([customer_info.countryCode]),
        ct: getNonNullValue([customer_info.city]),
        dob: '',
        ds: 'customer_info',
        em: getNonNullValue([customer_info.email]),
        fn: getNonNullValue([customer_info.firstName]),
        ge: '',
        id: getNonNullValue([customer_info.id]),
        ln: getNonNullValue([customer_info.lastName]),
        ph: getNonNullValue([customer_info.phone]),
        rc: getNonNullValue([customer_info.provinceCode]),
        rg: getNonNullValue([customer_info.province]),
        street: getNonNullValue([
          customer_info.address1,
          customer_info.address2,
        ]),
        zip: getNonNullValue([customer_info.zip]),
      });
    }

    // Create and add shipping fields if available
    if (shipping_address) {
      customerDataFields.push({
        cc: getNonNullValue([shipping_address.countryCode]),
        ct: getNonNullValue([shipping_address.city]),
        dob: '',
        ds: 'shipping',
        em: getNonNullValue([shipping_address?.email]),
        fn: getNonNullValue([shipping_address.firstName]),
        ge: '',
        id: '',
        ln: getNonNullValue([shipping_address.lastName]),
        ph: getNonNullValue([shipping_address.phone]),
        rc: getNonNullValue([shipping_address.provinceCode]),
        rg: getNonNullValue([shipping_address.province]),
        street:
          (shipping_address.address1 || '') + (shipping_address.address2 || ''),
        zip: getNonNullValue([shipping_address.zip]),
      });
    }

    // Create and add billing fields if available
    if (billing_address) {
      customerDataFields.push({
        cc: getNonNullValue([billing_address.countryCode]),
        ct: getNonNullValue([billing_address.city]),
        dob: '',
        ds: 'billing',
        em: getNonNullValue([billing_address?.email]),
        fn: getNonNullValue([billing_address.firstName]),
        ge: '',
        id: '',
        ln: getNonNullValue([billing_address.lastName]),
        ph: getNonNullValue([billing_address.phone]),
        rc: getNonNullValue([billing_address.provinceCode]),
        rg: getNonNullValue([billing_address.province]),
        street:
          (billing_address.address1 || '') + (billing_address.address2 || ''),
        zip: getNonNullValue([billing_address.zip]),
      });
    }

    // Create and add checkout fields if available
    if (checkout_info) {
      customerDataFields.push({
        cc: getNonNullValue([checkout_info.localization?.country?.isoCode]),
        ct: '',
        dob: '',
        ds: 'checkout',
        em: getNonNullValue([checkout_info.email]),
        fn: getNonNullValue([checkout_info.order?.customer?.firstName]),
        ge: '',
        id: getNonNullValue([checkout_info.order?.customer?.id]),
        ln: getNonNullValue([checkout_info.order?.customer?.lastName]),
        ph: getNonNullValue([checkout_info.phone]),
        rc: '',
        rg: '',
        street: '',
        zip: '',
      });
    }

    return customerDataFields;
  },
};
